import React, { useEffect, useState, useRef } from "react";
import { Amplify, API, graphqlOperation } from "aws-amplify";
import { getSharedApp, listSharedApps, searchSharedApps } from "../../graphql/queries";
import { reqByClientId, appsByClientId } from "../../graphql/custom-queries";
import { deleteSharedApp } from "../../graphql/mutations";
import HOME_IMPROVEMENT from "../../images/HI_1.png";
import ROOF from "../../images/ROOF_1.png";
import SOLAR from "../../images/SOLAR_1.png";
import BATTERY from "../../images/BATTERY_1.png";
import REMODELING from "../../images/REMODEL_1.png";
import BLANK from "../../images/BLANK_1.png";
import CONNECTED_ORGS from "../../images/connected_org.svg";
import {
  orgColumnIcon,
  orgColumnAlt,
  orgColumnTooltip,
} from "../../utils/orgListColumnIcon";
import { BiChevronRight, BiChevronLeft, BiChevronsLeft} from "react-icons/bi";
import {
  Heading,
  Button as LumosButton,
  AlertInline,
  Modal,
  ModalControls,
  useNotify,
  Icon,
  Badge
 } from "@loanpal/lumos__core";
import { Box } from "theme-ui";
import Loading from "../../utils/loading";
import NavBar from "../../shared/nav-bar";
import { formFields, components } from "../../utils/authentication";
import { useNavigate, useLocation } from "react-router-dom";
import { Status, StatusVariant  } from "../../utils/status";
import {
  formatDateTime
} from "../../utils/format";
import { getToken as getTokenApi } from "../../utils/api";
import QRCodeGenerator from "../../utils/qr-code-generator";

import {
  Authenticator,
  Table,
  TableCell,
  TableBody,
  TableHead,
  TableRow,
  SearchField,
  View,
  Flex,
  Menu,
  MenuItem,
  SelectField,
  Text,
  Card as ReactCard,
} from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import "../list-header-search.css";

import awsExports from "../../aws-exports";
Amplify.configure(awsExports);

const PARTNERS_LIST_SEARCH_LS_KEY = "cs-shared-app:partnersListSearchTerm";

function readPartnersListSearchTerm() {
  try {
    return String(localStorage.getItem(PARTNERS_LIST_SEARCH_LS_KEY) || "").trim();
  } catch {
    return "";
  }
}

function writePartnersListSearchTerm(term) {
  try {
    const t = String(term || "").trim();
    if (t) localStorage.setItem(PARTNERS_LIST_SEARCH_LS_KEY, t);
    else localStorage.removeItem(PARTNERS_LIST_SEARCH_LS_KEY);
  } catch {
    /* ignore quota / private mode */
  }
}

/** For OpenSearch `wildcard` values — escape \, *, ? */
function escapeOpenSearchWildcard(term) {
  return String(term).replace(/\\/g, "\\\\").replace(/\*/g, "\\*").replace(/\?/g, "\\?");
}

/** OpenSearch filter for partner search (aligns with common SRS / Roof Hub fields Requests often match on). */
function buildPartnerSearchOpenSearchFilter(term) {
  const escaped = escapeOpenSearchWildcard(term);
  return {
    or: [
      { clientId: { match: term } },
      { partnerName: { match: term } },
      // Account name (`partnerName`) substring — `match` often misses analyzed text (e.g. "SRS" in a longer name).
      { partnerName: { wildcard: `*${escaped}*` } },
      { partnerName: { matchPhrasePrefix: term } },
      { integratorId: { match: term } },
      // "SRS" must match "SRSIntegrator" etc.; `match` alone often misses single-token values.
      { integratorId: { wildcard: `*${escaped}*` } },
      { parentOrganizationClientId: { match: term } },
      { parentOrganizationClientId: { wildcard: `*${escaped}*` } },
      { organizationId: { match: term } },
      { organizationId: { wildcard: `*${escaped}*` } },
    ],
  };
}

/** Dynamo filter: `partnerName` contains substring (Partners "Account Name" = SharedApp.partnerName). */
function buildPartnerNameContainsFilter(term) {
  const t = (term || "").trim();
  if (!t) return null;
  const lower = t.toLowerCase();
  const upper = t.toUpperCase();
  if (lower === upper) {
    return { partnerName: { contains: t } };
  }
  return {
    or: [
      { partnerName: { contains: t } },
      { partnerName: { contains: lower } },
      { partnerName: { contains: upper } },
    ],
  };
}

/** Scan listSharedApps by partnerName substring (reliable vs OpenSearch for account-name matches). */
async function listSharedAppsPartnerNameContains(term) {
  const filter = buildPartnerNameContainsFilter(term);
  if (!filter) return [];
  const items = [];
  let nextToken = null;
  const pageLimit = 200;
  const maxPages = 30;
  for (let p = 0; p < maxPages; p++) {
    const res = await API.graphql(
      graphqlOperation(listSharedApps, {
        filter,
        limit: pageLimit,
        nextToken,
      })
    );
    const conn = res.data?.listSharedApps;
    items.push(...(conn?.items ?? []));
    nextToken = conn?.nextToken ?? null;
    if (!nextToken) break;
  }
  return items;
}

/** OpenSearch (@searchable) can lag DynamoDB; re-read authoritative fields by id. */
async function hydrateSharedAppsFromDynamo(apps) {
  if (!apps?.length) return apps;
  return Promise.all(
    apps.map(async (app) => {
      if (!app?.id) return app;
      try {
        const { data } = await API.graphql(
          graphqlOperation(getSharedApp, { id: app.id })
        );
        const fresh = data?.getSharedApp;
        return fresh ? { ...app, ...fresh } : app;
      } catch {
        return app;
      }
    })
  );
}

const Partners = () => {
  const [SharedApps, setSharedApps] = useState([]);
  const [sharedAppsCount, setSharedAppsCount] = useState();
  const [currentPageIndex, setCurrentPageIndex] = useState(1);
  const [totalPages, setTotalPages] = useState();
  const [nextToken, setNextToken] = useState(undefined);
  const [nextNextToken, setNextNextToken] = useState();
  const [previousTokens, setPreviousToken] = useState([]);
  const [spinner, setSpinner] = useState(false);
  const [isOpen, toggleOpen] = useState(false);
  const [isOpenLinks, toggleOpenLinks] = useState(false);
  const [accountName, setAccountName] = useState();
  const [sharedApp, setSharedApp] = useState();
  const [offers, setOffers ] = useState([])
  const [request, setRequest] = useState(null);
  const [appId, setAppId] = useState();
  const [appClientId, setAppClientId] = useState();
  const [isOpenQRCode, toggleOpenQRCode] = useState(false);
  const [qrDataUrl, setQrDataUrl] = useState("");
  const { addSnack } = useNotify();
  const inputRef = useRef(null);
  const [searchFieldKey, setSearchFieldKey] = useState(0);
  const [partnerSearchInputSeed, setPartnerSearchInputSeed] = useState(() =>
    readPartnersListSearchTerm()
  );
  const [listSearchRevision, setListSearchRevision] = useState(0);
  const [pageSize, setPageSize] = useState(35);

  const hasNext = !!nextNextToken && previousTokens.length < totalPages - 1
  const hasPrev = previousTokens.length
  const host = window.location.host;

 const sandbox_promotionId = "2345f0aa-db7a-42b9-807b-9e8a82b81ae3";
 const prod_promotionId =  "26d09475-32ec-448c-bb43-9f70aea55644";

  let navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    console.log("%c i fire once", "background: #222; color: #bada55", nextToken);
    const term = (partnerSearchInputSeed || "").trim();
    if (term) {
      fetchSharedApp(term);
    } else {
      fetchSharedApps();
    }
    // pathname + key: `/partners` and `/admin` share this component — remount is not guaranteed;
    // key changes on navigation (incl. browser back) so we re-run the saved search when re-entering the list.
    // partnerSearchInputSeed is initialized from localStorage and kept in sync on submit/clear/status.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    nextToken,
    pageSize,
    listSearchRevision,
    location.pathname,
    location.key,
    partnerSearchInputSeed,
  ]);

  const handlePageSizeChange = (e) => {
    setPageSize(parseInt(e, 10));
  };

   async function fetchSharedApps(listOpts) {
    try {
      setSpinner(true);
      const tokenForQuery =
        listOpts != null && Object.prototype.hasOwnProperty.call(listOpts, 'nextToken')
          ? listOpts.nextToken
          : nextToken;
      const appData = await API.graphql(graphqlOperation(searchSharedApps, {
        sort: {
          field: 'updatedAt',
          direction: 'desc'
        },
        limit: pageSize,
        nextToken: tokenForQuery
      }));
      console.log("APPS", appData.data, appData.data.searchSharedApps.items.length);
      if (appData.data.searchSharedApps.items.length > 0) {
        const apps = await hydrateSharedAppsFromDynamo(
          appData.data.searchSharedApps.items
        );
        const pages = Math.ceil(appData.data.searchSharedApps.total/pageSize);
        if (apps && apps.length > 0) {
          setSharedApps([...apps]);
          setSharedAppsCount(appData.data.searchSharedApps.total);
          setNextNextToken(appData.data.searchSharedApps.nextToken);
          setTotalPages(pages);
        }
      }
      setSpinner(false);
    } catch (err) {
      setSpinner(false);
      console.log("error fetching Shared Apps", err);
    }
  }

async function fetchSharedAppByStatus(st) {
  try {
    if (inputRef.current) {
      console.log(inputRef.current.value);
      inputRef.current.focus();
      inputRef.current.value = "";
    }
    writePartnersListSearchTerm("");
    setPartnerSearchInputSeed("");
    setSearchFieldKey((k) => k + 1);
    if (st === "ALL") {
      handleResetPage();
      setCurrentPageIndex(1);
      setListSearchRevision((r) => r + 1);
      return;
    }
    setSpinner(true);
    let nextToken = null;
    let SharedApps = [];

    // Keep fetching until there's no more nextToken
    do {
      const appData = await API.graphql(
        graphqlOperation(listSharedApps, {
          filter: { status: { eq: st } },
          nextToken: nextToken
        })
      );
      SharedApps = SharedApps.concat(appData.data.listSharedApps.items);
      nextToken = appData.data.listSharedApps.nextToken; // Update nextToken
    } while (nextToken);

    setSharedApps(SharedApps);
    setSharedAppsCount(SharedApps.length);
    handleResetPage();
    setSpinner(false);
  } catch (err) {
    console.log("error fetching Shared Apps", err);
  }
}

//  async function fetchSharedAppByStatus(st) {
//   try {
//         console.log(inputRef.current.value);
//         inputRef.current.focus();
//         inputRef.current.value = "";
//         if (st === "ALL")  { fetchSharedApps(); return; }
//         setSpinner(true);
//         const appData = await API.graphql(graphqlOperation(listSharedApps, { filter: { status: { eq: st } }}));
//         const SharedApps = appData.data.listSharedApps.items;
//         setSharedApps(SharedApps);
//         setSharedAppsCount(appData.data.listSharedApps.items.length);
//         setNextNextToken(appData.data.listSharedApps.nextToken);
//         handleResetPage();
//         setSpinner(false);
//       } catch (err) {
//         console.log("error fetching Shared Apps", err);
//     }
//   }

  async function getRequest(clientId, formUrl) {
      if (!clientId && clientId === "") return;
      try {
        const reqData = await API.graphql(
          graphqlOperation(reqByClientId, { clientId: clientId })
        );
        const req = reqData.data.reqByClientId.items[0];
        if (req) {
          setRequest(req);
        }
      } catch (err) {
        console.log("error fetching Request", err);
      }
    }

  async function fetchSharedApp(e) {
    const term = typeof e === "string" ? e.trim() : String(e).trim();
    if (term === "") return;
    setSpinner(true);
    try {
      const statusEl = document.getElementById("filterStatus");
      if (statusEl) statusEl.value = "ALL";
      /**
       * OpenSearch `match` on clientId often returns a single hit per value; DynamoDB
       * `appsByClientId` returns every SharedApp row for that partition key (same as
       * Request page). Merge Dynamo exact clientId hits with OpenSearch name / partial hits.
       */
      const [dynamoRes, partnerNameItems, appData] = await Promise.all([
        API.graphql(
          graphqlOperation(appsByClientId, {
            clientId: term,
            limit: 500,
          })
        ),
        listSharedAppsPartnerNameContains(term),
        API.graphql(
          graphqlOperation(searchSharedApps, {
            filter: buildPartnerSearchOpenSearchFilter(term),
            sort: { field: "updatedAt", direction: "desc" },
            limit: Math.max(pageSize, 100),
          })
        ),
      ]);
      const dynamoItems = dynamoRes.data.appsByClientId.items ?? [];
      const searchItems = appData.data.searchSharedApps?.items ?? [];

      const byId = new Map();
      for (const a of searchItems) {
        if (a?.id) byId.set(a.id, a);
      }
      for (const a of partnerNameItems) {
        if (a?.id) byId.set(a.id, a);
      }
      for (const a of dynamoItems) {
        if (a?.id) byId.set(a.id, a);
      }
      const apps = (
        await hydrateSharedAppsFromDynamo([...byId.values()])
      ).sort(
        (a, b) => new Date(b.updatedAt || 0) - new Date(a.updatedAt || 0)
      );

      handleResetPage();
      setCurrentPageIndex(1);
      setSharedApps(apps);
      setSharedAppsCount(apps.length);
      setNextNextToken(null);
      // Merged Dynamo + OpenSearch: no OpenSearch nextToken; show full result set (capped by Dynamo limit).
      setTotalPages(1);
    } catch (err) {
      console.log("error fetching Shared App", err);
    } finally {
      setSpinner(false);
    }
  }

  const loadSharedAppForEdit = (sharedAppId) => {
    navigate(`../edit/${sharedAppId}`, { replace: false });
  };

  const copyToClipBoard = async (copyMe) => {
    try {
      await navigator.clipboard.writeText(copyMe);
      addSnack({ variant: 'success', message: 'Link copied to clipboard' });
    } catch (err) {
      err.log("Failed to copy!");
      addSnack({ variant: 'danger', message: 'Error copying to clipboard' });
    }
  };

  const showGoodLinks = (sa) => {
    console.log("showGoodLinks", sa);
    getOffers(sa);
    getRequest(sa.clientId, sa.formUrl);
    setAccountName(sa.accountName);
    setSharedApp(sa);
    toggleOpenLinks(true);
  }

  const generateQRCode = (sa) => {
    setSharedApp(sa);
    setQrDataUrl("");
    toggleOpenQRCode(true);
  };

  const downloadQrCode = () => {
    if (!qrDataUrl) return;
    const clientId = (sharedApp?.clientId || "qrcode").toLowerCase();
    const a = document.createElement("a");
    a.href = qrDataUrl;
    a.download = `${clientId}-qrcode.png`;
    a.click();
  };

  const getPromotionId = () => {
  if (host.includes("sandox"))  {
      return sandbox_promotionId;
    } else  {
      return prod_promotionId;
    }
  }

  const getElevatedToken = async (parentOrganizationClientId, organizationId) => {
    const elevatedToken = await getTokenApi(parentOrganizationClientId, organizationId);
    if (elevatedToken) {
          return elevatedToken;
    } else {
      return null;
    }
  }

   const getOffers = async (sa) => {  
    try {
      let elevatedToken = null;
      if (sa.useConnectedOrgs && sa.parentOrganizationClientId && sa.organizationId) {
        elevatedToken = await getElevatedToken(sa.parentOrganizationClientId, sa.organizationId);      
        if (elevatedToken) {
          console.log("Elevated token received", elevatedToken);
        }
      }
      const myInit0 = {
        queryStringParameters: {
          apiId: `${sa.useConnectedOrgs ? sa.parentOrganizationClientId : sa.clientId}ApiId`,
          apiKey: `${sa.useConnectedOrgs ? sa.parentOrganizationClientId : sa.clientId}ApiKey`,
          clientId: sa.clientId,
          promotionId: getPromotionId(),
          channel: sa.channel,
          token: elevatedToken ? elevatedToken.token : null
        },
      };

      // get offers
      await API.get("developerApi", "/offers", myInit0)
      .then((response) => {
        console.log(response);
        if (response.data.length > 0) {
          setOffers(response.data);
        }
      })

    } catch (err) {
      console.log("error getting Offers");
      return false;
    }
  };


  const handleNextPage = () => {
    console.log('handleNextPage');
    setPreviousToken((prev) => [...prev, nextToken]);
    setNextToken(nextNextToken);
    setCurrentPageIndex(currentPageIndex + 1);
  };

  const handlePreviousPage = () => {
    console.log('handlePreviousPage');
    setNextToken(previousTokens.pop());
    setPreviousToken([...previousTokens]);
    setNextNextToken(null);
    setCurrentPageIndex(currentPageIndex - 1);
  };

  const handleResetPage = () => {
    setNextToken(undefined);
    setPreviousToken([]);
    setNextNextToken(null);
  }

  const clearPartnerSearchAndShowAll = () => {
    writePartnersListSearchTerm("");
    setPartnerSearchInputSeed("");
    setSearchFieldKey((k) => k + 1);
    const statusEl = document.getElementById("filterStatus");
    if (statusEl) statusEl.value = "ALL";
    handleResetPage();
    setCurrentPageIndex(1);
    setListSearchRevision((r) => r + 1);
  };

  const deleteIt = (id, clientId) => {
    console.log(id, clientId);
    setAppId(appId);
    setAppClientId(appClientId);
    toggleOpen(true);
  }

  const deleteApp = async () => {
    console.log(appId);
    try {
        await API.graphql(
          graphqlOperation(deleteSharedApp, { input: { id: appId }})
        );
        toggleOpen(false);
        const t = readPartnersListSearchTerm();
        if (t) fetchSharedApp(t);
        else fetchSharedApps({ nextToken: undefined });
    } catch (err) {
      console.log("error deteting Shared App", err);
      toggleOpen(false);
      addSnack({ variant: 'danger', message: 'Error deleting Shared App' });
    }
  }

  const newQuickLink = async (id) => {
    navigate(`../edit/new`, { replace: false });
  };

  const getCategory = (category) => {
    if (category === "HOME_IMPROVEMENT") return HOME_IMPROVEMENT
    else if (category === "ROOF") return ROOF;
    else if (category === "SOLAR") return SOLAR;
    else if (category === "BATTERY") return BATTERY;
    else if (category === "REMODELING") return REMODELING;
    else return "";
  }

  return (
    <Authenticator
      formFields={formFields}
      components={components}
      hideSignUp={true}
    >
      {({ signOut }) => (
        <>
          {spinner && <Loading />}
          <NavBar>
            <LumosButton onClick={signOut} style={styles.signOut}>
              Sign out
            </LumosButton>
          </NavBar>
          <div style={styles.container}>
            <Box>
              <Heading
                sx={{
                  backgroundColor: "#ffffff",
                  marginBottom: "20px",
                  fontSize: "22px",
                }}
              >
                <Flex
                  direction="row"
                  justifyContent="space-between"
                  alignItems="flex-end"
                  alignContent="flex-end"
                  wrap="wrap"
                  gap="1rem"
                >
                  <View style={{ flexShrink: 0 }}>
                    Partner List <span style={styles.count}>({sharedAppsCount})</span>
                  </View>
                  <Flex
                    direction="row"
                    alignItems="flex-end"
                    gap="0.75rem"
                    style={{ flex: '0 1 auto', maxWidth: '100%', marginLeft: 'auto' }}
                  >
                    <View
                      className="list-header-search"
                      style={{
                        width: 'clamp(14rem, 42vw, 32rem)',
                        minWidth: '12rem',
                        maxWidth: '25rem',
                      }}
                    >
                      <SearchField
                        key={searchFieldKey}
                        ref={inputRef}
                        label="Search"
                        placeholder="Search by client ID or account name…"
                        size="small"
                        style={{ width: '100%', maxWidth: '100%' }}
                        defaultValue={partnerSearchInputSeed}
                        onSubmit={(e) => {
                          const term =
                            typeof e === "string"
                              ? e.trim()
                              : String(e).trim();
                          if (term === "") return;
                          writePartnersListSearchTerm(term);
                          setPartnerSearchInputSeed(term);
                          setSearchFieldKey((k) => k + 1);
                          setListSearchRevision((r) => r + 1);
                        }}
                        onClear={() => {
                          writePartnersListSearchTerm("");
                          setPartnerSearchInputSeed("");
                          setSearchFieldKey((k) => k + 1);
                          const statusEl = document.getElementById("filterStatus");
                          if (statusEl) statusEl.value = "ALL";
                          handleResetPage();
                          setCurrentPageIndex(1);
                          setListSearchRevision((r) => r + 1);
                        }}
                      />
                    </View>
                    <LumosButton
                      type="button"
                      onClick={clearPartnerSearchAndShowAll}
                      style={{ flexShrink: 0, whiteSpace: 'nowrap', marginBottom: '2px' }}
                    >
                      Show all
                    </LumosButton>
                  </Flex>
                </Flex>
              </Heading>
              <Box>
              <Heading
                sx={{
                  backgroundColor: "#ffffff",
                  fontSize: "22px",
                }}
              >
              <Flex
                direction="row"
                justifyContent="space-between"
                alignItems="stretch"
                alignContent="flex-start"
                wrap="nowrap"
                gap="1rem"
              >
                <Box sx={{
                    width: 250,
                    marginBottom: 20
                  }}>
                    <SelectField
                      id="filterStatus"
                      style={styles.input}
                      descriptiveText="Filter by Status"
                      onChange={(e) => fetchSharedAppByStatus(e.target.value)}
                      size="small"
                    >
                      <option value="ALL">All Partners</option>
                      <option value="ACTIVE">{Status.ACTIVE}</option>
                      <option value="INPROGRESS">{Status.INPROGRESS}</option>
                      <option value="NOTACTIVE">{Status.NOTACTIVE}</option>
                      <option value="PENDING">{Status.PENDING}</option>
                      <option value="BLOCKED">{Status.BLOCKED}</option>
                      <option value="SUSPENDED">{Status.SUSPENDED}</option>
                      <option value="TEST">{Status.TEST}</option>
                    </SelectField>
                </Box>
                <LumosButton onClick={newQuickLink} style={styles.newQuickLinkButton}>
                  New QuickLink
                </LumosButton>
              </Flex>
              </Heading>
              </Box>
              {SharedApps.length ? (
                <>
                <Table caption="" highlightOnHover={false} size="small" variation="striped">
                  <TableHead>
                    <TableRow>
                      <TableCell as="th">Status</TableCell>
                      <TableCell as="th">Client Id</TableCell>
                      <TableCell as="th">Account Name</TableCell>
                      <TableCell as="th">Last Updated</TableCell>
                      <TableCell as="th">Cat</TableCell>
                      <TableCell as="th">Org</TableCell>
                      <TableCell as="th">CO</TableCell>
                      <TableCell as="th"></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {SharedApps.map(({id, status: st, partnerName, clientId, category, updatedAt, formUrl, integratorId, bundleClientId, useConnectedOrgs, parentOrganizationClientId }, index, sharedApps) => (
                      <TableRow key={id ? id : index}>
                        <TableCell><Badge variant={StatusVariant.find(el => el.type === st).variant}>{`${Status[st]}`}</Badge></TableCell>
                        <TableCell>{clientId}</TableCell>
                        <TableCell>{partnerName}</TableCell>
                        <TableCell>{formatDateTime(updatedAt)}</TableCell>
                        <TableCell>
                          <img src={getCategory(category)} alt={category} style={styles.catLogo} />
                        </TableCell>
                        <TableCell>
                         <img
                            src={orgColumnIcon(parentOrganizationClientId, integratorId, bundleClientId)}
                            alt={orgColumnAlt(parentOrganizationClientId, integratorId, bundleClientId)}
                            title={orgColumnTooltip(
                              parentOrganizationClientId,
                              integratorId,
                              bundleClientId
                            )}
                            style={styles.corpLogo}
                          />
                        </TableCell>
                        <TableCell>
                          <img src={useConnectedOrgs ? CONNECTED_ORGS : BLANK} alt={useConnectedOrgs ? "Connected Orgs" : "Not Connected Orgs"} style={styles.connectedOrgLogo} />
                        </TableCell>
                        <TableCell>
                          <View width="4rem">
                            <Menu menuAlign="start" size="small">
                             <MenuItem size="small" onClick={() => loadSharedAppForEdit(id)}><Icon variant="edit" size="sm" sx={{marginRight: '5px'}} />Edit</MenuItem>
                              <MenuItem size="small" onClick={() => deleteIt(id, clientId)}><Icon variant="trash" size="sm" sx={{marginRight: '5px'}} />Delete</MenuItem>
                              {(st === "ACTIVE" || st === "TEST")  && <MenuItem size="small" onClick={() => showGoodLinks(sharedApps[index])}><Icon variant="envelope" size="sm" sx={{marginRight: '5px'}} />Show GoodLinks</MenuItem>}
                              <MenuItem size="small" onClick={() => {copyToClipBoard(formUrl)}}><Icon variant="clipboard" size="sm" sx={{marginRight: '5px'}} />Copy GL to Clipboard</MenuItem>
                              <MenuItem size="small" onClick={() => generateQRCode(sharedApps[index])}><Icon variant="grid" size="sm" sx={{marginRight: '5px'}} />Generate QR Code</MenuItem>
                            </Menu>
                          </View>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                <Box sx={{ marginTop: 20 }}>
                <Flex
                  direction="row"
                  justifyContent="center"
                  alignItems="stretch"
                  alignContent="flex-start"
                  wrap="nowrap"
                  gap="1rem"
                >
                {totalPages > 0 && (
                  <>
                    <LumosButton disabled={!hasPrev} onClick={handleResetPage} style={styles.paginationButton}>
                      <BiChevronsLeft size={'1rem'} /> First Page
                    </LumosButton>
                    <LumosButton disabled={!hasPrev} onClick={handlePreviousPage} style={styles.paginationButton}>
                      <BiChevronLeft size={'1rem'} /> Prev Page
                    </LumosButton>
                    <LumosButton disabled={!hasNext} onClick={handleNextPage} style={styles.paginationButtonRight}>
                      Next Page <BiChevronRight size={'1rem'} />
                    </LumosButton>
                    <SelectField
                      id="pageSize"
                      style={styles.select}
                      descriptiveText="Page Size"
                      onChange={(e) => handlePageSizeChange(e.target.value)}
                      size="small"
                      value={pageSize}
                    >
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option value="20">20</option>
                    <option value="25">25</option>
                    <option value="35">35</option>
                  </SelectField>
                  </>
                )}
              </Flex>
                </Box>
                </>
              ) : (
                <AlertInline variant="info">No items found.</AlertInline>
              )}
            </Box>
            <Box
              sx={{
                marginBottom: "100px",
              }}
            >
              &nbsp;
            </Box>
          </div>
          <Modal isOpen={isOpen} onDismiss={() => toggleOpen(false)} title="Delete Shared App">
          <Heading
                sx={{
                  backgroundColor: "#ffffff",
                  fontSize: "18px",
                }}
              >
            Are you sure you want to delete {appClientId ? appClientId : 'it'}?
            </Heading>
            <ModalControls actions={[
                {
                  onClick: () => deleteApp(),
                  label: 'Delete',
                },
                {
                  onClick: () => toggleOpen(false), label: 'Cancel'
                }
              ]}
            />
          </Modal>
          {/* Modal to Generate QR Code */}
          <Modal variant="large" isOpen={isOpenQRCode} onDismiss={() => toggleOpenQRCode(false)} title="Generate QR Code">
            <Box sx={{ padding: '10px 0', display: 'flex', justifyContent: 'center' }}>
              {sharedApp?.formUrl && (
                <QRCodeGenerator url={sharedApp.formUrl} onDataUrlChange={setQrDataUrl} />
              )}
            </Box>
            <ModalControls actions={[
                {
                  onClick: downloadQrCode,
                  label: 'Download PNG',
                },
                {
                  onClick: () => toggleOpenQRCode(false), label: 'Close'
                }
              ]}
            />
          </Modal>
             {/* Modal to Display GoodLink */}
          <Modal variant="large" isOpen={isOpenLinks} onDismiss={() => toggleOpenLinks(false)} title="GoodLinks">
          <Heading
                sx={{
                  backgroundColor: "#ffffff",
                  fontSize: "18px",
                  whiteSpace: "pre-line"
                }}
              >
            {accountName}
            </Heading>
            <Box
                sx={{
                  backgroundColor: "#ffffff",
                  fontSize: "14px",
                  fontWeight: "100px",
                  whiteSpace: "pre-line"
                }}
              >
            {sharedApp  &&(
              <>
              {request && offers && (
                  <Box
                  sx={{
                    backgroundColor: "#ffffff",
                    fontSize: "14px",
                    fontWeight: "100px",
                    whiteSpace: "pre-line"
                  }}
                >
                  <ReactCard>
                  <Box
                  sx={{
                    paddingBottom: "20px",
                    whiteSpace: "pre-line"
                  }}
                  >
                  <Heading variant="h5" width="50%">GoodLink with all offers <Icon variant="clipboard" size="sm" onClick={e =>copyToClipBoard(sharedApp.formUrl)} sx={{cursor: "pointer", color: "green"}}/></Heading>
                  <Text
                    lineHeight="1.5em"
                    fontSize="1em"
                    width="100%"
                  >
                    {sharedApp.formUrl}
                  </Text>
                  </Box>
                  {sharedApp.partnerName.endsWith('-dk') && (
                    <Heading variant="h5" width="50%">No Single offer links for Daikin GoodLinks</Heading>
                  )}
                  {!sharedApp.partnerName.endsWith('-dk') && (
                  <>
                  <Heading variant="h5" width="50%">Single offer links </Heading>
                  {/* <Text
                    lineHeight="1.5em"
                    fontSize="1em"
                    width="100%"
                  >
                    {request.offer.split(",").map((o, index) => (
                      <li key={index}>{`${sharedApp.formUrl}/${o}`} <Icon variant="clipboard" size="sm" onClick={e =>copyToClipBoard(`${sharedApp.formUrl}/${o}`)} sx={{cursor: "pointer", color: "green"}}/></li>
                    ))}
                  </Text> */}

                   {offers.map((o, index) => (
                      <Text
                      lineHeight="1.5em"
                      fontSize="1em"
                      width="100%"
                      key={index}
                    >
                      <li key={index}>{`${o.name} - ${o.productName}`} <Icon variant="clipboard" size="sm" onClick={e =>copyToClipBoard(`${sharedApp.formUrl}/${o.offerId}`)} sx={{cursor: "pointer", color: "green"}}/></li>
                    </Text>
                   ))}

                  </>)}
                </ReactCard>
                </Box>
              )}
            <ModalControls actions={[
                {
                  onClick: () => { toggleOpenLinks(false) }, label: 'Close'
                }
              ]}
            />
            </>
            )}
           </Box>
          </Modal>
          {/* END Modal to Send Communication emails */}
        </>
      )}
    </Authenticator>
  );
};

const styles = {
  container: {
    maxWidth: "1440px",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    backgroundColor: "#ffffff",
    padding: "20px 20px"
  },
  divider: { margin: "25px 0", color: "white" },
  space: { marginTop: "20px" },
  app: { marginBottom: 15 },
  input: {
    marginBottom: 20,
    padding: 6,
    fontSize: 16,
    // width: "250px"
  },
  select: {
    marginBottom: 0,
    padding: 6,
    fontSize: 12,
    // width: "30px"
  },
  switch: {
    marginBottom: 10,
    // padding: 8,
    fontSize: 16,
  },
  appClientId: { fontSize: 20, fontWeight: "bold" },
  appFields: { marginBottom: 0 },
  button: {
    backgroundColor: "#003439",
    color: "white",
    outline: "none",
    fontSize: 18,
    padding: "12px 0px",
    cursor: "pointer",
  },
  menuButton: {
    backgroundColor: "#00838f",
  },
  newQuickLinkButton: {
    width: 150,
    height: 40,
  },
  buttonDisabled: {
    opacity: 0.8,
    backgroundColor: "#007680",
    color: "white",
    outline: "none",
    fontSize: 18,
    padding: "12px 0px",
    cursor: "notAllowed",
  },
  signOut: {
    marginRight: 10,
  },
  logo: {
    width: 400,
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: 20,
  },
  paginationButton: {
    marginTop: "30px",
    width: 130,
    height: 40,
  },
  paginationButtonRight: {
    width: 130,
    height: 40,
    marginTop: "30px",
    marginLeft: "200px"
  },
  heading: {
    backgroundColor: "#003439",
  },
  clipboardButton: {
    cursor: "pointer",
  },
  catLogo: {
    width: 25,
    position: "relative",
    top: 5,
    margin: "0 auto",
  },
  corpLogo: {
    width: 25,
    position: "relative",
    top: 5,
    margin: "0 auto",
  },
  count: {
    fontSize: "80%",
    fontWeight: 100,
    position: "relative",
    top: -1
  },
  connectedOrgLogo: {
    width: 15,
    position: "relative",
    top: 5,
    margin: "0 auto",
  }
};

export default Partners;
